import React from "react";
import SystemPage from "pages/Admin/Settings/SystemPage"
import Facilities from "services/Admin/FacilitiesService"

const FacilitiesPage = (props) => {
        return <SystemPage
                Service={Facilities}
                type={"Facility"}
                placeholder={"facility"}
                meta={"Facilities "}
                header={"Facility"} 
                hasSub={false}
        /> 

}

export default FacilitiesPage;
